import { useCallback, useEffect, useRef } from 'react';

type UsePreAuthTimeoutResponse = {
  startPreAuthTimeout: () => void;
  clearPreAuthTimeout: () => void;
};

export const usePreAuthTimeout = (onTimeout: () => void, timeout = 10000): UsePreAuthTimeoutResponse => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const clearPreAuthTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const startPreAuthTimeout = useCallback(() => {
    clearPreAuthTimeout();
    timeoutRef.current = setTimeout(() => {
      timeoutRef.current = null;
      onTimeout();
    }, timeout);
  }, [onTimeout, clearPreAuthTimeout, timeout]);

  useEffect(() => () => clearPreAuthTimeout(), [clearPreAuthTimeout]);

  return { startPreAuthTimeout, clearPreAuthTimeout };
};
